import { render, staticRenderFns } from "./listEvents.vue?vue&type=template&id=5710bc79&"
import script from "./listEvents.vue?vue&type=script&lang=js&"
export * from "./listEvents.vue?vue&type=script&lang=js&"
import style0 from "./listEvents.vue?vue&type=style&index=0&script=css&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports